// Angular
import { Directive, Input, TemplateRef, ViewContainerRef, DoCheck, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { Subscription } from 'rxjs';

// Models
import { AppCleanup } from '../models';

// Services
import { AuthService } from '../../modules/auth/services';

interface PermissionCheck {
	roles?: string[];
	hide?: boolean;
}

@Directive({
	selector: '[isGranted]',
})
export class IsGrantedDirective extends AppCleanup implements DoCheck, OnInit, OnDestroy {
	@Input('isGranted') check: PermissionCheck;

	private hasView = false;

	private accessSubscription: Subscription = null;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private authService: AuthService
	) {
		super();
	}

	ngDoCheck() {
		if (this.check.roles && this.check.roles.length === 0 && !this.hasView) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			this.hasView = true;
			return;
		}

		if (!this.accessSubscription)
			this.accessSubscription = this.authService
				.checkAccess(
					this.check ? this.check.roles : null,
					() => {
						if (this.hasView) {
							this.viewContainer.clear();
							this.hasView = false;
						}
					},
					() => {
						if (!this.hasView) {
							this.viewContainer.createEmbeddedView(this.templateRef);
							this.hasView = true;
						}
					}
				)
				.subscribe();

		if (this.check && this.check.hide) {
			if (this.hasView) {
				this.viewContainer.clear();
				this.hasView = false;
			}

			return;
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.accessSubscription) this.accessSubscription.unsubscribe();
	}
}
